<template>
     <div class="container-fluid">
            <div class="page-title">
              <div class="row">
                <div :class="btn?'col-6':'col-8'">
                  <h4>{{title}}</h4>
                </div>
                <div :class="btn?'col-6':'col-4'"> 
               <router-link v-if="btn" to="/gatepass" class="btn btn-primary text-white">Create Gatepass</router-link>
                  <!--<ol class="breadcrumb">-->
                    
                  <!--  <router-link to="/dashboard" class="breadcrumb-item">Dashboard</router-link>-->
                  <!--  <li to="/form" class="breadcrumb-item active">{{title}}</li>-->
                  <!--</ol>-->
                </div>
              </div>
            </div>
          </div>
</template>

<script> 

export default {
  name: 'PageTitle',
  props: {
    title: String,
    btn: String
  }
  
}
</script>
 
